<template>
  <div class="cancel-container">
    <h1>Payment Canceled</h1>
    <p>Your payment has been canceled. If this was a mistake, you can try again.</p>
    <router-link to="/" class="btn">Return to Homepage</router-link>
  </div>
</template>

<script>
export default {
  name: "PaymentCanceled",
};
</script>

<style scoped>
.cancel-container {
  font-family: Arial, sans-serif;
  background: #f8f8f8;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #333;
  padding: 2rem;
  box-sizing: border-box;
}

h1 {
  color: #e74c3c;
  margin-bottom: 1rem;
}

p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  text-align: center;
  max-width: 400px;
}

.btn {
  text-decoration: none;
  background-color: #3498db;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #2980b9;
}
</style>
